module.exports = __webpack_public_path__ + "assets/dcc57a600d3238d72647fe51185fad24.jpg";